import {noCof} from "./cof/NoCof";
import {cofOneClick} from "./cof/OneClick";
import {COF_TYPE_ONECLICK, COF_TYPE_SCHEDULED, COF_TYPE_UNSCHEDULED} from "./BridgeConstants";
import {cofScheduled} from "./cof/Scheduled";
import {cofUnscheduled} from "./cof/Unscheduled";

export const bridgeResultFactory = (cofType, config, finish, receive) => {
  if (cofType === COF_TYPE_ONECLICK) {
    return cofOneClick(cofType, config, finish, receive);
  }
  if (cofType === COF_TYPE_SCHEDULED) {
    return cofScheduled(cofType, config, finish, receive);
  }
  if (cofType === COF_TYPE_UNSCHEDULED) {
    return cofUnscheduled(cofType, config, finish, receive);
  }
  return noCof(cofType, config, finish, receive);
};



// WEBPACK FOOTER //
// ./src/bridge/BridgeMethodsFactory.js